import {
  bet9jaProdId,
  bet9jaStgId,
  mamabetProdId,
  mamabetStgId,
} from '../../../../config'

export const CACHE_PURGE_WEBSITES: Record<string, string> = {
  [bet9jaStgId]: 'https://website-purge.stg.bo.logifuture.com',
  [bet9jaProdId]: 'https://website.bet9ja.com',
  [mamabetStgId]: 'https://stg-demo.logifuture.com',
  [mamabetProdId]: 'https://demo.logifuture.com',
}

export const getCachePurgeWebsite = (organizationId?: string) =>
  organizationId ? CACHE_PURGE_WEBSITES[organizationId] : undefined
